/** @module SourcingOrders/UnitsPerSize */
define([
	"dojo/_base/declare",
	"csi/heading/Number",
	"csi/html"
], function(declare,Number,html) {

	return declare(Number, {
		/**
		 * @override
		 * Render value for matrix cell
		 */
		toValue: function(ctx, h) {
			const order = ctx.getNodeContext();
			const size = ctx.getNodeURL();

			if (!order || !size) {
				return "";
			}
			const poProduct = ctx.cache.getNode(order.POProduct);
			const indexOfSize = poProduct && poProduct.ProductSizes.findIndex(s => s==size);

			const value = order.UnitsPerSize ? order.UnitsPerSize[indexOfSize] : "";
			return this.formatValue(value);
		}
	});
});